if (!customElements.get('db-series')) {
  customElements.define(
    'db-series',
    class DbSeries extends HTMLElement {
      connectedCallback() {
        this.series = DbSeries.seriesName(this.dataset.title);
        if (this.series.length < 2) return;
        // Chargement différé : la section est sous la ligne de flottaison
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.hidden = false;
        // repliée (hauteur nulle) tant que les résultats ne sont pas chargés
        this.classList.add('is-pending');
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // Mot-clé de la série : « Daredevil Born Again S2 – Blu Ray » → « Daredevil »,
      // « Star Wars : Andor S1 » → « Andor », « TWD Daryl Dixon » → « TWD », « The Boys » → « Boys »
      static seriesName(title) {
        let name = (title || '').replace(/\s*[–—-]\s*blu[\s-]?ray.*$/i, '');
        // « Star Wars : Andor » → la série ; « The Punisher : One Last Kill » → The Punisher (sous-titre ignoré)
        if (/\s:\s/.test(name)) {
          const [before, after] = name.split(/\s:\s/);
          name = /^(star wars|seigneur des anneaux)$/i.test(before.trim()) ? after : before;
        }
        name = name.split(/\s+[–—-]\s+/)[0];
        name = name.replace(/\s+(S\d+.*|Saison\s*\d+.*|Int[ée]grale.*)$/i, '');
        const stop = ['the', 'le', 'la', 'les', 'de', 'des', 'du', 'un', 'une'];
        const word = name
          .split(/[\s'’-]+/)
          .find((w) => w.length >= 3 && !stop.includes(DbSeries.normalize(w)));
        return (word || name).trim();
      }

      static normalize(text) {
        return (text || '')
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .toLowerCase()
          .trim();
      }

      load() {
        const params = new URLSearchParams({
          q: this.series,
          type: 'product',
          'options[prefix]': 'last',
          section_id: 'db-series-results',
        });
        fetch(`${this.dataset.searchUrl}?${params.toString()}`)
          .then((response) => response.text())
          .then((html) => this.render(html))
          .catch(() => (this.hidden = true));
      }

      render(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // le mot-clé doit apparaître comme mot entier dans le titre (« Iron » ne prend pas « IronHeart »)
        const keyword = new RegExp(`(^|[^a-z0-9])${DbSeries.normalize(this.series).replace(/[^a-z0-9]/g, '')}([^a-z0-9]|$)`);
        const items = Array.from(doc.querySelectorAll('[data-db-series-results] > li'))
          .filter((li) => li.dataset.productId !== this.dataset.productId)
          .filter((li) => keyword.test(DbSeries.normalize(li.dataset.title)))
          .sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, 'fr', { numeric: true }))
          .slice(0, parseInt(this.dataset.limit, 10) || 8);

        if (items.length === 0) {
          this.hidden = true;
          return;
        }
        this.classList.remove('is-pending');
        this.querySelector('.db-series__name').textContent = `· ${this.series}`;
        const list = this.querySelector('[data-db-series-list]');
        items.forEach((li) => list.appendChild(document.importNode(li, true)));
      }
    }
  );
}

/* Mini-galerie « Dans le même univers » (fiche produit) : saisons trouvées par mot-clé. */
if (!customElements.get('db-seasons')) {
  customElements.define(
    'db-seasons',
    class DbSeasons extends HTMLElement {
      // Ordre : séries les plus « spécifiques » d'abord (ex. Daredevil Born Again avant Daredevil),
      // puis saisons de la plus récente à la plus ancienne : BA S2, BA S1, Daredevil S3, S2, S1
      static sortKey(title) {
        const t = (title || '').replace(/\s*[\u2013\u2014-]\s*blu[\s-]?ray.*$/i, '').trim();
        const m = t.match(/\b(?:S|Saison\s*)(\d+)\b/i);
        const season = m ? parseInt(m[1], 10) : 0;
        const series = t.replace(/\s*[\u2013\u2014-]?\s*\b(?:S\d+|Saison\s*\d+|Int[\u00e9e]grale).*$/i, '').trim();
        return { series, season };
      }

      sortItems() {
        Array.from(this.children)
          .map((el) => ({ el, ...DbSeasons.sortKey(el.dataset.dbSeasonTitle) }))
          .sort((a, b) => b.series.length - a.series.length || a.series.localeCompare(b.series, 'fr') || b.season - a.season)
          .forEach(({ el }) => this.appendChild(el));
      }

      connectedCallback() {
        if (this.hasAttribute('data-static')) {
          this.sortItems();
          return;
        }
        const Series = customElements.get('db-series');
        const keyword = Series.seriesName(this.dataset.title);
        const wrapper = this.closest('[data-db-seasons-wrapper]');
        if (keyword.length < 2) {
          if (wrapper) wrapper.hidden = true;
          return;
        }
        const pattern = new RegExp(`(^|[^a-z0-9])${Series.normalize(keyword).replace(/[^a-z0-9]/g, '')}([^a-z0-9]|$)`);
        const params = new URLSearchParams({ q: keyword, type: 'product', 'options[prefix]': 'last', section_id: 'db-seasons-results' });
        fetch(`${this.dataset.searchUrl}?${params.toString()}`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const found = Array.from(doc.querySelectorAll('[data-db-seasons-results] > a'))
              .filter((a) => a.dataset.productId !== this.dataset.productId)
              .filter((a) => pattern.test(Series.normalize(a.dataset.dbSeasonTitle)))
              .slice(0, 11);
            if (!found.length) {
              if (wrapper) wrapper.hidden = true;
              return;
            }
            found.forEach((a) => this.appendChild(document.importNode(a, true)));
            this.sortItems();
          })
          .catch(() => wrapper && (wrapper.hidden = true));
      }
    }
  );
}
